import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, where, orderBy, limit, startAfter, endBefore } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storageInstance = getStorage()
const storageImages = ref(storageInstance, "subscriptionsImages/");

export default {
    state:{
        subscriptionsList: [],
        subscriptionsGettedByUsers:[],
        analyticsSubscription: [],
        loadingStatusSubscriptionImage:0,
        actualPageSubscriptionsGetted:1
    },
    mutations:{
        SET_SUBSCRIPTIONS_LIST(state, subscriptionsList){
            state.subscriptionsList = subscriptionsList
        },
        SET_VALUE_LOADING_STATUS_SUBSCRIPTION_IMAGE(state, progress) {
            state.loadingStatusSubscriptionImage = progress
        },
        SET_SUBSCRIPTIONS_GETTED_BY_USERS_LIST(state, subscriptionsGettedByUsers){
            state.subscriptionsGettedByUsers = subscriptionsGettedByUsers
        },
        SET_COUNTER_SUBSCRIPTIONS_GETTED_BY_USERS_LIST(state, analyticsSubscription){
            state.analyticsSubscription = analyticsSubscription
        },
        SET_PAGE_SUBSCRIPTIONS_GETTED(state, page){
            state.actualPageSubscriptionsGetted = page
        }
        
    },
    actions:{
                UploadImageSubscription({ commit }, subscription) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `subscriptionsImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, subscription.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetSubscriptionsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(query(collection(db, "subscriptionsList"), where("id", "!=", "Yn8R3ywqutpbFmyPoAbt"))); //where added for not get "free" subscription
                    const subscriptionsList = []
                    querySnapshot.forEach((doc) =>  {
                        subscriptionsList.push(doc.data())
                    })
                    commit('SET_SUBSCRIPTIONS_LIST', subscriptionsList)
                    resolve(subscriptionsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateSubscription({}, subscription) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete subscription.image.img
                                         const newDocRef = doc(collection(db, "subscriptionsList"));
                     subscription.id = newDocRef.id;
                     subscription.createdAt = new Date()
                     subscription.updatedAt = new Date()
                     await setDoc(newDocRef, subscription)
                     resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateSubscription({}, subscription) {
            return new Promise(async(resolve, reject) => {
                try {
                    if (subscription.image.img) {
                        delete subscription.image.img
                    }
                    if(subscription.createdAt) {
                        delete subscription.createdAt
                    }
                    subscription.updatedAt = new Date()
                    await updateDoc(doc(db, "subscriptionsList", subscription.id), subscription)
                    resolve(subscription.id);
                } catch (error) {
                    reject(err);
                }
            });
        },
        DeleteSubscription({}, subscription) {
            return new Promise(async(resolve, reject) => {
                try {
                                         let storageRefImage = ref(storageInstance, `subscriptionsImages/${subscription.image.ref}`);
                    await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "subscriptionsList", subscription.id))
                    resolve(subscription.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetAllSubscriptionsUser({}, uid){
            return new Promise(async (resolve, reject) => {
                try {
                                         const userReference =  doc(db, "users", uid);
                    const querySnapshot = await getDocs(query(collection(db, "subscriptionsGettedByUsers"), where('user', "==", userReference), orderBy('duration.startDate', 'desc')));
                    const userSubscriptionsList = []
                    console.log('querySnapshot', querySnapshot.docs.length);
                    
                    querySnapshot.docs.forEach(async (doc) =>  {
                        let userSubscription = doc.data()
                        let typeSubscription = await getDoc(userSubscription.typeSubscription)
                        userSubscription.typeSubscription = typeSubscription.data()
                        userSubscriptionsList.push(userSubscription)
                    })
                    console.log('userSubscriptionsList', userSubscriptionsList);
                    
                    resolve(userSubscriptionsList)
                } catch(error) {
                    reject(error)
                }
            })

        },
        /**
         * Intentos de validar un recibo de tienda para este usuario.
         * No devuelve receiptData ni purchaseToken: son la credencial del recibo.
         */
        GetUserReceiptsHistory({}, uid){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(query(
                        collection(db, "receiptsHistory"),
                        where("userId", "==", uid),
                        orderBy("processedAt", "desc"),
                        limit(50)
                    ));
                    const rows = querySnapshot.docs.map((snap) => {
                        const data = snap.data();
                        return {
                            id: snap.id,
                            app: data.app || "",
                            source: data.source || "",
                            result: data.result || "",
                            productId: data.productId || "",
                            originalTransactionId: data.originalTransactionId || "",
                            errorDetails: data.errorDetails || "",
                            notificationType: data.notificationType || "",
                            processedAt: data.processedAt || null,
                        };
                    });
                    resolve(rows);
                } catch (error) {
                    reject(error);
                }
            });
        },
        AddSubscriptionToUser({}, subscriptionPayload){
            return new Promise(async (resolve, reject) => {
                try {
                    // 🚀 USAR FUNCIÓN HTTP DEL BACKEND (con transacciones y validaciones)
                    const response = await fetch('https://us-central1-maxfit-app.cloudfunctions.net/addSubscriptionFromDashboard', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(subscriptionPayload)
                    });
                    
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || errorData.error || 'Failed to add subscription');
                    }
                    
                    const subscriptionId = await response.text(); // Backend retorna solo el ID como string
                    resolve(subscriptionId);
                } catch (error) {
                    reject(error);
                }
            })
        },
        async GetSubscriptionsGettedByUsersList({ commit, getters }, options){
            return new Promise(async (resolve, reject) => {
                try {
                    let ref = collection(db, "subscriptionsGettedByUsers")
                    // const referenceFreeSubscription = db.collection("subscriptionsList").doc('Yn8R3ywqutpbFmyPoAbt')

                    let querySnapshot = null
                    if(options.page === 1){
                        // querySnapshot = options.isFree ? ref.orderBy('duration.startDate', 'desc').limit(options.itemsPerPage) : ref.orderBy('typeSubscription').orderBy('duration.startDate', 'desc').limit(options.itemsPerPage).where('typeSubscription', '!=', referenceFreeSubscription)
                                                 querySnapshot = query(ref, orderBy('duration.startDate', 'desc'), limit(options.itemsPerPage))
                    }else if(options.page > getters.getActualPageSubscriptionsGetted){
                        let lastValue = getters.getSubscriptionsGettedByUsers[getters.getSubscriptionsGettedByUsers.length - 1].duration.startDate
                        console.log('lastValue', lastValue);
                        // querySnapshot = options.isFree ? ref.orderBy('duration.startDate', 'desc').startAfter(lastValue).limit(options.itemsPerPage) : ref.orderBy('typeSubscription').orderBy('duration.startDate', 'desc').startAfter(lastValue).limit(options.itemsPerPage).where('typeSubscription', '!=', referenceFreeSubscription)
                                                 querySnapshot = query(ref, orderBy('duration.startDate', 'desc'), startAfter(lastValue), limit(options.itemsPerPage))
                    }else if(options.page < getters.getActualPageSubscriptionsGetted){
                        let firstValue = getters.getSubscriptionsGettedByUsers[0].duration.startDate
                        console.log('firstValue', firstValue);
                        // querySnapshot = options.isFree ? ref.orderBy('duration.startDate', 'desc').endBefore(firstValue).limitToLast(options.itemsPerPage) : ref.orderBy('typeSubscription').orderBy('duration.startDate', 'desc').endBefore(firstValue).limitToLast(options.itemsPerPage).where('typeSubscription', '!=', referenceFreeSubscription)
                                                 querySnapshot = query(ref, orderBy('duration.startDate', 'asc'), startAfter(firstValue), limit(options.itemsPerPage))
                    }
                    querySnapshot = await getDocs(querySnapshot)
                    let subscriptionsUsersList = []

                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let subscriptionUser = querySnapshot.docs[i].data();
                        subscriptionUser.typeSubscription = await getDoc(subscriptionUser.typeSubscription)
                        subscriptionUser.user = await getDoc(subscriptionUser.user)
                        subscriptionsUsersList.push(subscriptionUser);
                    }

                    //·····································
                    // querySnapshot.forEach((doc) => {
                    //     let subscriptionUser = doc.data()
                    //     subscriptionUser.susc
                    //     subscriptionsUsersList.push(subscriptionUser);
                    // });
                    commit('SET_PAGE_SUBSCRIPTIONS_GETTED', options.page)
                    commit('SET_SUBSCRIPTIONS_GETTED_BY_USERS_LIST', subscriptionsUsersList)

                    resolve(subscriptionsUsersList)
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        GetAllSubscriptionsGettedByUsersList(){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "subscriptionsGettedByUsers"))

                    console.log(querySnapshot)

                }catch(error){

                }
            })

        },
        async GetCounterSubscriptionsGettedByUsers({ commit }, isFree){
            return new Promise(async (resolve, reject) => {
                try {
                    let ref = collection(db, "subscriptionsAnalytics")
                    const querySnapshot = isFree ? await getDocs(ref) : await getDocs(query(ref, where("id", "!=", "Yn8R3ywqutpbFmyPoAbt")));
                    let analyticsSubscription = []
                    querySnapshot.forEach((doc) => {
                        let analytics = doc.data()
                        analyticsSubscription.push(analytics);
                    });
                    commit('SET_COUNTER_SUBSCRIPTIONS_GETTED_BY_USERS_LIST', analyticsSubscription)
                    resolve(analyticsSubscription)
                } catch (error) {
                    reject(error)
                }
            })

        }
    },
    getters:{
        getSubscriptionsList(state){
            return state.subscriptionsList;
        },
        getLoadingStatusSubscriptionImage(state){
            return state.loadingStatusSubscriptionImage;
        },
        getSubscriptionsGettedByUsers(state){
            return state.subscriptionsGettedByUsers;
        },
        counterSubscriptionsGetted(state){
            return state.analyticsSubscription.map(subscription => subscription.total).reduce((a, b) => a + b, 0);
        },
        getActualPageSubscriptionsGetted(state){
            return state.actualPageSubscriptionsGetted
        }
    }
}